export default "__VITE_ASSET__BvsuH7Gb__"